/**
 * Check if cookies are enabled and displays warning message if they are disabled.
 */
if (!navigator.cookieEnabled) {
  document.querySelector('#no-cookies-warning').classList.remove('hide');
}
